exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* GEN 8 */\n[go-back] {\n  position: relative; }\n  [go-back] img {\n    display: none;\n    margin-left: 9%; }\n  @media (max-width: 768px) {\n    [go-back] {\n      padding: 20px 0; }\n      [go-back] * {\n        display: none; }\n      [go-back] img {\n        display: block; } }\n", ""]);

